//babel js/smartab.js --presets=@babel/preset-env --minified -s -o js/smartab_babel.js

(function($){

    if(window.navigator.userAgent.indexOf('Trident') > -1) {
        $('.ie-grid').addClass('flex flex-wrap justify-center')
        $('.ie-grid').children('div').addClass('flex-none p-[15px] w-full sm:w-1/2 md:w-1/3 lg:w-1/4')
        $('.ie-grid-item-margin').removeClass('p-[15px]').addClass('m-[15px]')
        $('.ie-no-flex').removeClass('flex')

    }else{
        const minHeight = function(){$('.min-h-screen').css('min-height', (window.innerHeight - $('#wpadminbar').height()) + 'px')}
        window.addEventListener('resize', minHeight)
        minHeight()
    }

    let subnavInterval

    const subnavHandle = () => {
        $('#subnav').hide()
        clearInterval(subnavInterval)
        const isSmall = $(window).width() < 1024

        const navs = $('#primary_menu li a')
        const subnav = $('#subnav')

        let openSubnav = false
        let closeCountdown = 0

        const writeSubnav = (e) => {
            const writeFrom = $('#subnav-' + getId(e))
            if(writeFrom.length > 0) {
                subnav.html(writeFrom.html())
                return true
            } else {
                return false
            }
        }

        const subnavTouchHandle = (navs) => {
            $('#content').click((e)=>{
                if(
                    $(e.currentTarget).hasClass('subnav-mobile') ||
                    $(e.currentTarget).hasClass('mobile-menu-item')
                ) return true
                $('#site-navigation').removeClass('toggled')
            })

            navs.click((e)=>{
                const thisSubnav = $('#subnav-mobile-' + getId(e))

                if(thisSubnav.length > 0 && 
                    $('.subnav-text:hover').length === 0) {
                    e.preventDefault()
                } else {
                    return
                }

                if(openSubnav === getId(e)){
                    $('#menu-item-' + getId(e) + ' .navpil').css('transform', 'rotate(0)')
                    thisSubnav.slideUp()
                    openSubnav = false
                } else {
                    $('#menu-item-' + getId(e) + ' > a .navpil').css('transform', 'rotate(90deg)')
                    thisSubnav.slideDown()
                    openSubnav = getId(e)
                }
            })

            $(`
                .current-page-ancestor > a,
                .current_page_item > a,
                body.woocommerce-page #site-navigation .menu-item-74 > a
            `).click()

            let term = document.body.className.replace(/.*term-([0-9]+).*/, "$1")
            term = parseInt(term)
            if(term > 0) $('#menu-item-' + term + ' > a').click()
        }

        const subnavClickHandle = (navs, subnav) => {
            subnavInterval = setInterval(()=>{
                const hovers = $('#primary_menu li a:hover')
                if(hovers.length === 1) {
                    $('#primary_menu li a').removeClass('navhover')
                    hovers.addClass('navhover')
                    if(openSubnav !== getId(hovers.eq(0))) {
                        subnav.fadeOut(200, ()=>{
                            if(writeSubnav(hovers.eq(0))) {                                    
                                subnav.slideDown()
                                openSubnav = getId(hovers.eq(0))
                                closeCountdown = 3
                            } else {
                                openSubnav = false
                            }
                        })
                    }
                } else {
                    if($('#subnav:hover').length === 0) {
                        if(closeCountdown > 0) {
                            closeCountdown -= 1
                            return
                        }
                        $('#primary_menu li a').removeClass('navhover')
                        subnav.fadeOut()
                        openSubnav = false
                    }
                }
            }, 100)
        }

        if('ontouchstart' in window || isSmall) subnavTouchHandle(navs, subnav)
        else subnavClickHandle(navs, subnav)
    }

    const getId = (e)=>{
        let id = $(e.currentTarget ?? e).closest('.menu-item, .mobile-menu-item').attr('id')
        id = parseInt(id.split('-').slice(-1)[0])
        return id
    }

    $('#primary_menu > li > a').each(function(){
        if($('#subnav-' + getId(this)).length === 0) return
        $(
            '<div id="subnav-mobile-' + getId(this) + '" class="subnav-mobile hidden">' +
            $('#subnav-' + getId(this)).html() +
            '</div>'
        ).insertAfter(this)
    })

    $('#primary_menu > li > a .navpil').each(function(){
        const thisSubnav = $(this).parent().parent().siblings('.subnav-mobile')
        if(thisSubnav.length === 0) {
            $(this).hide()
        }
    })

    subnavHandle()
    $(window).resize(subnavHandle)

    let toggledLength = -1

    setInterval(()=>{
        if($('#site-navigation.toggled').length !== toggledLength) {
            toggledLength = $('#site-navigation.toggled').length
            if(toggledLength > 0) {
                $('body').css('overflow', 'hidden')
                $('html, body').animate({scrollTop: 0}, 100)
                $('#site-navigation').css('right', '0')
            } else {
                $('body').css('overflow', 'auto')
                $('#site-navigation').css('right', '100%')
            }
        }
    }, 100)

    $('#header-search .search-submit-header').click(function(e) {
        const searchfield = $('#header-search .search-field')
        if(searchfield.is(':hidden')) {
            e.preventDefault()
            searchfield.val('')
            searchfield.show('fast', ()=>searchfield.focus())
        }
    })

})(jQuery)
